module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 018-e76f1a99b9a90970167d7468c60fd9f1.png";